import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBurgerIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 25,
	viewBox: "0 0 28 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 27,
			height: 4,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: 10.5,
			width: 27,
			height: 4,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: 20.5,
			width: 27,
			height: 4,
			fill: "white"
		})
	]
});
export default SvgBurgerIcon;
